export const setDestinationTestConnectionResult =
  'setDestinationTestConnectionResult';
